import { render, staticRenderFns } from "./responsaveis-finep.captacao.vue?vue&type=template&id=af9823e0&"
import script from "./responsaveis-finep.captacao.vue?vue&type=script&lang=js&"
export * from "./responsaveis-finep.captacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports